import dayjs from 'dayjs';
import { isRemoteHRTimesheetAttachmentUrl } from '@/utils/hrTimesheetAttachment';

export function partyNameOnly(name) {
  if (name == null || String(name).trim() === '') return '—';
  return String(name).trim();
}

export function formatIsoToUs(isoDate) {
  if (!isoDate) return '';
  const parts = String(isoDate).split('-');
  if (parts.length !== 3) return '';
  const [year, month, day] = parts;
  if (!year || !month || !day) return '';
  return `${String(month).padStart(2, '0')}/${String(day).padStart(2, '0')}/${year}`;
}

/** MM/DD/YYYY → YYYY-MM-DD for API / edit form */
export function parseUsToIso(usDate) {
  if (!usDate) return '';
  const parts = String(usDate).split('/');
  if (parts.length !== 3) return '';
  const [month, day, year] = parts.map((p) => p.trim());
  if (!year || !month || !day) return '';
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

export function formatCreatedAt(value) {
  if (value === null || value === undefined || value === '') return '—';
  return dayjs(value).format('MM/DD/YYYY h:mm A');
}

export function consultantIdFromSheet(sheet) {
  const id = sheet?.consultantId;
  if (id == null || String(id).trim() === '') return '';
  return String(id).trim();
}

export function statusBadgeClass(status, mode) {
  if (mode === 'hr') {
    switch (status) {
      case 'Submitted':
        return 'status-submitted';
      case 'Approved':
        return 'status-approved';
      case 'Processed':
        return 'status-processed';
      default:
        return 'status-default';
    }
  }
  switch (status) {
    case 'Time Sheet Created':
      return 'status-submitted';
    case 'Invoice Done':
      return 'status-approved';
    case 'Payment Received':
    case 'Partial Payment Received':
      return 'status-processed';
    default:
      return 'status-default';
  }
}

export function billBadgeClass(billStatus) {
  switch (billStatus) {
    case 'Bill Paid':
      return 'status-processed';
    case 'Bill Created':
      return 'status-approved';
    case 'Not Applicable':
    default:
      return 'status-default';
  }
}

export function needsStoredAttachmentActions(att) {
  return !isRemoteHRTimesheetAttachmentUrl(att?.filePath);
}
